var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12",staticStyle:{"min-height":"80vh"}},[_c('p',[_vm._v("Check out our articles for guides and info on edibles and dosing.")]),_vm._l((_vm.articles),function(a){return _c('article-stub',{key:a.title,attrs:{"article":a}})})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }